module.exports = __webpack_public_path__ + "img/mc-donalds.40d39184.png";